import React from "react";
import Typist from 'react-typist';

const PageLoader = () => {
    const styles = {
        position: "absolute",
        left: 0, right: 0,
        top: 0, bottom: 0,
        margin: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
        overflow: "auto",
        color: "#605E59",
        width: "fit-content",
        height: "fit-content",
        lineHeight: "initial"
    }

    const [theClass, setTheClass] = React.useState(true)

    React.useEffect(() => {
        setTimeout(() => setTheClass(false), 2750)
    }, [])

    return (
        <div className="title" style={styles}>
            <Typist ms={10} className={`${theClass ? "m-fadeIn" : "fadeInOut"} loader line animated delay00 fadeInFast`} >
                Hi, <br />
                I am David Ayọ.
            </Typist>
        </div>
    )
}

export default PageLoader;